import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import welcomePhoto from '../assets/welcomePhoto.png';
import { useAuth } from '../AuthContext';
import MealTile from '../components/MealTile';
import HostAccessModal from '../components/HostAccessModal';

const Dashboard = () => {
  const { currentUser, isHost } = useAuth();
  const navigate = useNavigate();
  const [showAccessModal, setShowAccessModal] = useState(false);

  const handleCreateListing = () => {
    if (isHost) {
      navigate('/create-listing');
    } else {
      setShowAccessModal(true);
    }
  };

  const handleAccessGranted = () => {
    navigate('/create-listing');
  };

  if (!currentUser) {
    return (
      <div className="dashboard-container">
        <p className="dashboard-loading">Loading...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <img
        src={welcomePhoto}
        alt="Welcome"
        className="dashboard-image"
      />

      <div className="dashboard-card">
        <MealTile />

        <button className="create-listing-button" onClick={handleCreateListing}>
          Create Listing
        </button>
      </div>

      <HostAccessModal
        isOpen={showAccessModal}
        onClose={() => setShowAccessModal(false)}
        onSuccess={handleAccessGranted}
      />
    </div>
  );
};


export default Dashboard;
